var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FavoritesAppbar'),_c('br'),_c('br'),_c('div',{staticClass:"mt-8 mx-auto px-2",staticStyle:{"max-width":"800px"}},[_c('PrayersList'),_c('JoinTelegram',{staticClass:"mt-4"}),_c('SharePopup')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }